import Component from '../../classes/Component';
import intlTelInput from 'intl-tel-input';
import {$dom} from "../../helpers/dom";
import {getMeta, isElement} from "../../helpers/_utilities";
import {$events} from "../../helpers/events";
import InputMask from 'inputmask';
import variables from "../../variables";
import {$style} from "../../helpers/style";
import 'intl-tel-input/build/js/utils';


const rootSelector = '.'+variables.classNames.intlTelInput;
const parentSelector = '.js-intl-parent';
const defaultPlaceholder = '(***) ***-**-**';
const byPlaceholder = '(**) ***-**-**';
const kgPlaceholder = '(***) **-**-**';
const gePlaceholder = '(***) **-**-**';

const getPlaceholder = pl => pl.replaceAll('*', '9');


export default function () {

    return new Component({
        name: 'intlTelInput',
        requiredTargets: rootSelector,
        onCreate() {
            this.initCountry = getMeta('country');

            this.countries = {
                ru:  'Россия',
                by:  'Беларусь',
                kz:  'Казахстан',
                uz:  'Узбекистан',
                kg:  'Кыргызстан',
                ge:  'Грузия',
            };

            this.handlePlaceholderChange = function() {
                if (this.intlTel) {
                    let tempVal;

                    if (this.value.trim()) {
                        tempVal = this.value;
                        this.value = '';
                    }

                    const placeholder = $dom.attr(this, 'placeholder');

                    if (!placeholder) return;

                    if (this.mask && this.mask.remove) this.mask.remove();

                    this.mask = InputMask({
                        mask: placeholder,
                        showMaskOnHover: false,
                        keepStatic: true
                    }).mask(this);

                    if (tempVal) this.value = tempVal;
                }
            };

            const toggleBlur = action => {
                if ($dom.hasClass(document.body, variables.classNames.intlTelInputMobile)) {
                    if ($dom[action])
                        $dom[action](variables.dom.wrapper, variables.classNames.blurred)
                }
            };

            this.provideValueToHiddenInput = (arg) => {
                let input = arg;

                if (arg instanceof Event)
                    input = arg.target;

                const parent = input.closest(parentSelector);

                if (isElement(parent)) {
                    const hiddenInput = $dom.get('input[name="phone"][type="hidden"]', parent);
                    if (input.intlTel && input.intlTel.getNumber())
                        hiddenInput.value = input.intlTel.getNumber();
                }
            };

            this.createIntlTelInput = target => {
                target.intlTel = intlTelInput(target, {
                    initialCountry: this.initCountry,
                    formatOnDisplay: true,
                    separateDialCode: true,
                    onlyCountries: Object.keys(this.countries),
                    localizedCountries: this.countries,
                    hiddenInput: 'phone',
                    customPlaceholder: function(selectedPlaceholder, selectedData) {
                        switch (selectedData?.iso2) {
                            case 'ru':
                            case 'kz':
                                return getPlaceholder(defaultPlaceholder);
                            case 'by':
                            case 'uz':
                                return getPlaceholder(byPlaceholder);
                            case 'kg':
                                return getPlaceholder(kgPlaceholder);
                            case 'ge':
                                return getPlaceholder(gePlaceholder);
                            default: return selectedPlaceholder;
                        }
                    },
                });

                target.intlTel.promise.then(() => {
                    this.handlePlaceholderChange.call(target);
                    this.provideValueToHiddenInput(target)
                });

                return target.intlTel
            };

            this.handleOpen = () => toggleBlur('addClass');
            this.handleClose = () => toggleBlur('removeClass');
        },
        onInit() {

            $dom.each(this.targets, this.createIntlTelInput);

            $events.delegate
                .on('countrychange', rootSelector, this.handlePlaceholderChange)
                .on('open:countrydropdown', rootSelector, this.handleOpen)
                .on('close:countrydropdown', rootSelector, this.handleClose)
                .on('input', rootSelector, this.provideValueToHiddenInput)
        },
        onDestroy() {
            $dom.each(this.targets, target => {
                if (target.intlTel) {
                    $style.remove(target, 'padding-left');
                    target.intlTel.destroy();
                }
                if (target.mask) target.mask.remove()
            });

            $events.delegate
                .off('countrychange', rootSelector, this.handlePlaceholderChange)
                .off('open:countrydropdown', rootSelector, this.handleOpen)
                .off('close:countrydropdown', rootSelector, this.handleClose)
                .off('input', rootSelector, this.provideValueToHiddenInput)
        }
    })
}
